import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const analyticsRepurchaseIncentivePage = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen: 'modal resgate',
    product: 'sortezinha',
    content_action: 'dado carregado',
    adjust_event_token: '0',
    flow: 'prateleira',
  })
}

export const analyticsRepurchaseIncentiveLoad = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen: 'modal resgate',
    screen_name: 'Sortezinha:ModalResgate',
    product: 'sortezinha',
    product_area: 'ModalResgate',
    step: '0',
    scenario: 'prateleira',
  })
}

export const analyticsConfirmRepurchaseIncentiveTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '81',
    screen: 'modal resgate',
    ref_type: 'botao',
    content_action: 'toque',
    action_id: 'garantir nova capitalização',
    adjust_event_token: '0',
    product: 'sortezinha',
    flow: 'resgate',
  })
}

export const analyticsDismissRepurchaseIncentiveTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '82',
    screen: 'modal resgate',
    ref_type: 'botao',
    content_action: 'toque',
    action_id: 'agora não',
    adjust_event_token: '0',
    product: 'sortezinha',
    flow: 'resgate',
  })
}
